import { Component, ViewEncapsulation, Input, TemplateRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'sacyr-modal',
  templateUrl: './sacyr-modal.component.html',
  styleUrls: ['./sacyr-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SacyrModalComponent {
  @Input() set setTemplateRef(modal_content: TemplateRef<any>) {
    this.modal_content = modal_content;
  }

  @Input() set showModal(_showModal: boolean) {
    this._showModal = _showModal;
  }

  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  _showModal = false;
  modal_content: TemplateRef<any>;

  onCloseModal() {
    this._showModal = false;
    this.closeModal.emit(this._showModal);
  }
}